import { apiPatch } from '../client';

export async function updateSalesOrderCategory(id: number, category: string): Promise<void> {
  return apiPatch<void>(`transactions/sales-orders/${id}/category`, { category });
}
